import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { zendeskService } from "services";
import { uiActions } from "store";
import { ErrorResponse, ZendeskTicketType } from "types";

const useAddZendeskTicketMutation = (onSuccess: Function) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			data,
			applicationId,
		}: {
			data: ZendeskTicketType;
			applicationId: string;
		}) => zendeskService.addZendeskTicket({ data, applicationId }),
		{
			onSuccess(link: string) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Ticket has been successfully added",
					}),
				);
				onSuccess?.();
				link && window.open(link, "_blank");
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useAddZendeskTicketMutation;
